/**
  Copyright (c) [2022]
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

// Vue Imports
import { defineComponent } from 'vue';
// Components Imports
import HeaderDashboard from '@/components/header/header.vue';
import FooterDashboard from '@/components/footer/footer.vue';
import Paginator from '@/components/pagination/pagination.vue';
import QRScanner from '@/views/QRScanner/QRScanner.vue';

import { useNotificationStore } from '@dafcoe/vue-notification';
// Third party components
import moment from 'moment';
import VueElementLoading from 'vue-element-loading';
// store
import { mapState, mapActions } from 'vuex';
// Service Imports
import EventService from '@/services/event';
// Router Imports
import router from '@/router';
// Defining Component
export default defineComponent({
  data() {
    return {
      selectedissuerec: null,
      uEmail: '',
      uName: '',
      reissuemodal: false,
      recentOrderPayload: null,
      selectedEvent: null,
      recsdata: null,
      defselected: null,
      defName: '',
      totalPages: 1,
      tickRecord: null,
      showModel: false,
      isloading: false,
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
      list: [],
      searchtext: '',
      searchactive: false,
      showQRModal: false,
      enableButton: false,
    };
  },
  components: {
    HeaderDashboard,
    FooterDashboard,
    QRScanner,
    Paginator,
    'vue-element-loading': VueElementLoading,
  },
  computed: {
    ...mapState('events', ['selectedEvent']),
    getDetails() {
      let rr: any = localStorage.getItem('record');
      if (rr) {
        rr = JSON.parse(rr) as any;
        this.setSelectedEvent(rr);
      }

      if (
        rr &&
        rr.eventOwners &&
        rr.eventOwners[0] &&
        rr.eventOwners[0].ownershipType
      ) {
        return rr.eventOwners[0].ownershipType;
      }
      return '';
    },
  },
  methods: {
    ...mapActions('events', ['setSelectedEvent', 'setRecentOrderPayload']),
    showQRModalPopup() {
      this.showQRModal = true;
    },
    scanData(type: string) {
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.attendeeReport({
          eventId: (this.selectedEvent as any).eventCode,
          userId: user.userId,
          type: type,
        })
          .then((rrr) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: rrr.Message,
              type: rrr.Status == 'Success' ? 'success' : 'error',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    closeQRModal() {
      this.showQRModal = false;
    },
    removeunderscore(text: string) {
      const data = text.replaceAll('_', ' ').toLowerCase().split(' ');
      for (let i = 0; i < data.length; i++) {
        data[i] = data[i][0].toUpperCase() + data[i].substr(1);
      }
      return data.join(' ');
    },
    checkin(e: any, rec: any) {
      e.stopPropagation();
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        this.isloading = true;
        EventService.scanResult({
          scannerUserId: user.userId,
          ticketOrderCode: rec.orderCode,
        })
          .then((response: any) => {
            this.isloading = false;

            rec.totalScanned = Number(rec.totalPurchasedTickets);
            const scannedAt =
              response.Result?.scannedTickets?.createdAt ||
              response.Result?.createdAt ||
              new Date().toISOString();
            rec.scannedTickets = {
              ...(rec.scannedTickets || {}),
              createdAt: scannedAt,
              scannerUserId:
                response.Result?.scannedTickets?.scannerUserId || user.userId,
              scannerUser: response.Result?.scannedTickets?.scannerUser || {
                id: user.id,
                fullName: user.fullName,
              },
            };
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
          })
          .catch((err: any) => {
            this.isloading = false;
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    cleartext() {
      this.searchtext = '';
      this.makesearch();
    },
    makesearch() {
      if (this.searchtext.trim().length > 0) {
        this.searchactive = true;
      } else {
        this.searchactive = false;
      }
      this.search(1);
    },
    search(n: any) {
      const load = {
        eventId: (this.selectedEvent as any).eventCode,
        ticketId: this.defselected,
        type: 'ALL',
        page: n,
        attendeeName: this.searchtext,
      };

      if (this.defselected == -2) {
        (load as any).ticketId = '';
      }
      this.isloading = true;
      EventService.searchOrders(load)
        .then((response: any) => {
          if (response.Result && response.Result.data) {
            (this.list as any) = [...response.Result.data];
          }

          this.totalPages = response.Result.pagination.totalPages;
          this.isloading = false;
        })
        .catch((err: any) => {
          this.isloading = false;
        });
    },
    dropTicket(e: any) {
      if (e.target.value != -1 && e.target.value != -2) {
        const load = {
          eventId: (this.selectedEvent as any).eventCode,
          ticketId: e.target.value,
          type: 'ALL',
          page: 1,
        };

        localStorage.setItem('record1', JSON.stringify(load));
        this.isloading = true;
        EventService.fetchRecentOrders(load)
          .then((response: any) => {
            if (response.Result && response.Result.data) {
              this.list = response.Result.data;
            }

            this.totalPages = response.Result.pagination.totalPages;
            this.isloading = false;
          })
          .catch((err: any) => {
            this.isloading = false;
          });
      } else if (e.target.value == -2) {
        const load = {
          eventId: (this.selectedEvent as any).eventCode,
          ticketId: '',
          type: 'ALL',
          page: 1,
        };

        localStorage.setItem('record1', JSON.stringify(load));
        this.isloading = true;
        EventService.fetchRecentOrders(load)
          .then((response: any) => {
            if (response.Result && response.Result.data) {
              this.list = response.Result.data;
            }

            this.totalPages = response.Result.pagination.totalPages;
            this.isloading = false;
          })
          .catch((err: any) => {
            this.isloading = false;
          });
      }
    },
    nextPage(pgno: any) {
      if (!this.recentOrderPayload) {
        router.push('/events');
        return;
      }

      let rr: any = localStorage.getItem('record1');
      if (rr) {
        rr = JSON.parse(rr);
        if (Object.keys(rr || {}).length > 0) {
          (this.recentOrderPayload as any) = rr;
        }
      }
      if (this.searchactive) {
        this.search(pgno);
        return;
      }
      const load = { ...(this.recentOrderPayload as any) };
      load.page = pgno;
      this.isloading = true;
      EventService.fetchRecentOrders(load)
        .then((response: any) => {
          if (response.Result && response.Result.data) {
            this.list = response.Result.data;
          }

          if (
            response.Result.pagination.currentPage <
            response.Result.pagination.totalPages
          ) {
            this.totalPages = response.Result.pagination.totalPages;
          }
          this.isloading = false;
        })
        .catch((err: any) => {
          this.isloading = false;
        });
    },
    getDate(date: string) {
      return moment(date).format('MMM DD, YYYY');
    },
    getTime(date: string) {
      return moment(date).format('hh:mm A');
    },
    formatDateTime(date: string) {
      return this.getDate(date) + ' ' + this.getTime(date);
    },
    export() {
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        EventService.exportOrder({
          eventId: (this.selectedEvent as any).eventCode,
          userId: user.userId,
        })
          .then((response) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
          })
          .catch((err) => {
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    close() {
      this.tickRecord = null;
      this.showModel = false;
    },
    closem() {
      this.reissuemodal = false;
      this.uName = '';
      this.uEmail = '';
    },
    open(tickRecord: any) {
      this.tickRecord = tickRecord;
      this.showModel = true;
    },
    resend(e: any, rec: any) {
      e.stopPropagation();
      let user: any = localStorage.getItem('user');
      if (user) {
        user = JSON.parse(user);
        this.isloading = true;
        EventService.resend({
          orderId: rec.orderCode,
        })
          .then((response: any) => {
            this.isloading = false;
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
          })
          .catch((err: any) => {
            this.isloading = false;
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
    reissue(e: any, rec: any) {
      this.selectedissuerec = rec;
      e.stopPropagation();
      this.reissuemodal = true;
    },
    invalidTicketEmail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.uEmail
      );
    },
    submitm(e: any, rec: any) {
      e.stopPropagation();
      let user: any = localStorage.getItem('user');
      if (
        this.selectedissuerec &&
        user &&
        this.uName.trim().length > 0 &&
        this.uEmail.trim().length > 0
      ) {
        user = JSON.parse(user);
        this.isloading = true;
        EventService.reIssue({
          orderId: (this.selectedissuerec as any).orderCode,
          userName: this.uName,
          userEmail: this.uEmail,
        })
          .then((response: any) => {
            this.closem();
            this.isloading = false;
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: 'success',
              showIcon: false,
            });
            location.reload();
          })
          .catch((err: any) => {
            this.closem();
            this.isloading = false;
            const { setNotification } = useNotificationStore();
            setNotification({
              message:
                err.response && err.response.data && err.response.data.Message
                  ? err.response.data.Message
                  : 'Something went wrong',
              type: 'error',
              showIcon: false,
            });
          });
      }
    },
  },
  created() {
    if (!this.selectedEvent) {
      let rr = localStorage.getItem('record');
      if (rr) {
        rr = JSON.parse(rr);
        this.setSelectedEvent(rr);
      }
    }
  },
  mounted() {
    let self = this;
    let rrs: any = localStorage.getItem('record');
    if (rrs) {
      rrs = JSON.parse(rrs);
      (this.recsdata as any) = {
        eventId: rrs.eventCode,
        page: 1,
        ticketId: '',
        type: 'ALL',
      };
      (this.selectedEvent as any) = rrs;
      (this.selectedEvent as any).donationTickets =
        (this.selectedEvent as any).donationTickets || [];
      (this.selectedEvent as any).freePaidTickets =
        (this.selectedEvent as any).freePaidTickets || [];

      EventService.paginatedEventDetail({
        eventId: rrs.eventCode,
      })
        .then((responss: any) => {
          (this.selectedEvent as any) = responss.Result;
        })
        .finally(() => {
          this.isloading = false;

          let rr: any = localStorage.getItem('record1');
          if (rr) {
            rr = JSON.parse(rr);
            if (Object.keys(rr || {}).length > 0) {
              (this.recentOrderPayload as any) = rr;
            } else {
              (this.recentOrderPayload as any) = this.recsdata;
            }
          }

          if (!(this.selectedEvent as any)) {
            router.push('/events');
            return;
          }

          [
            ...((this.selectedEvent as any).donationTickets || []),
            ...((this.selectedEvent as any).freePaidTickets || []),
          ].forEach((element: any) => {
            if (
              element.ticketCode ==
              ((this.recentOrderPayload || {}) as any).ticketId
            ) {
              this.defName = element.ticketName;
            }
          });
          this.defselected = ((this.recentOrderPayload || {}) as any).ticketId;
          if (!this.defselected || this.defselected == '') {
            (this.defselected as any) = -2;
            this.defName = 'All Ticket(s) Orders';
          }

          this.search(this.selectedEvent);
        });
    }
    window.scrollTo(0, 0);

    self.isloading = true;
    EventService.fetchRecentOrders(this.recsdata || this.recentOrderPayload)
      .then((response: any) => {
        if (response.Result && response.Result.data) {
          self.list = response.Result.data;
        }

        self.totalPages = response.Result.pagination.totalPages;
      })
      .finally(() => {
        self.isloading = false;
      });

    const id = 'scannerids';

    if (document.getElementById(id) === null || !(window as any).JsQRScanner) {
      let script = document.createElement('script');
      script.setAttribute(
        'src',
        'https://manager.myle.com/jsqrscanner.nocache.js'
      );
      script.setAttribute('id', id);
      document.body.appendChild(script);

      // now wait for it to load...
      script.onload = () => {
        self.enableButton = true;
      };
    } else {
      self.enableButton = true;
    }
  },
});
